import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {
  Config, initialConfigState,
  isLoading, updateScreenWidth, updateScrenHeight,
} from "./modules/redux";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {environment} from "../environments/environment";
import {MatDialog} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {delay, filter, fromEvent, Subscription} from "rxjs";
import {loadLookup} from "./modules/redux/stores/lookups/lookups.actions";
import {LookupType} from "./models";
import {AppFade} from "./animations/animations";
import { IAppLoader } from './models/iloader';
import { DataService } from './services/data/data.service';
import { PermissionsDebugComponent } from './debug/permissions-debug/permissions-debug.component';
import * as Sentry from "@sentry/angular";
import packageJson from '../../package.json';
import { CoreService } from './services/core.service';
import { BrowserTracing } from '@sentry/tracing';
import { AuthService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [AppFade()]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.altKey && event.key === 'd') {
      this.dataService.print();
    }
    // else if (event.ctrlKey && event.altKey && event.key === 'p') {
    //   // launch permissions debug
    //   this.dialog.open(PermissionsDebugComponent, { minHeight: '600px', minWidth: '900px' }) 
    // }
  }

   @HostListener('window:focus', [])
  onWindowFocus() {
    console.log('Browser/tab is focused again');
    this.authService.ValidateAndRefreshToken().subscribe(isValid => {
      if (!isValid) {
        console.log('Token is invalid');
      } else {
        console.log('Token is valid or refreshed');
      }
    });
  }

  appVersion = packageJson.version;
  animationState = true;
  config$: Subscription = new Subscription();
  loading$: Subscription = new Subscription();
  navigating$: Subscription = new Subscription();
  config: Config = initialConfigState;

  isLoading = false;
  message: string = '';
  isNavigating = false;

  constructor(
    private store: Store,
    public dialog: MatDialog,
    public toastrService: ToastrService,
    private authService: AuthService,
    private router: Router,
    private dataService: DataService,
  ) {

    this.router.events
    .pipe(
      filter(event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      )
    )
    .subscribe(event => {
      if (event instanceof NavigationStart) {
        // console.log("Router event:", event.toString(), event.url?.toString() ?? "<no url>");

        this.isLoading = true;
      } else {
        // console.log("Router event:", event.toString(), event.url?.toString() ?? "<no url>");

        setTimeout(() => {
          this.isLoading = false;
        }, 900);
      }
    });

    // this.coreService.loading$.subscribe(({ loading, message }) => {
    //   setTimeout(() => {
    //     this.isLoading = loading;
    //     this.message = message;
    //   });
    // });


    // Initialize Sentry
    if (window.location.hostname !== 'localhost') {
      // console.log("Initializing Sentry with config...");
      Sentry.init({
        release: this.appVersion,
        environment: environment.sentry_trace,
        // tunnel: environment.rondeivu_api + '/sentry',
        dsn: environment.sentry_dns,
        debug: !environment.production,
        _experiments: { enableLogs: true },
        integrations: [
          // new BrowserTracing({
          //   tracingOrigins: ['localhost', 'yourdomain.com'],
          // }),
          // Registers and configures the Tracing integration,
          // which automatically instruments your application to monitor its
          // performance, including custom Angular routing instrumentation
          // Sentry.browserTracingIntegration(),
          // Registers the Replay integration,
          // which automatically captures Session Replays
          // Sentry.replayIntegration(),

          Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: [environment.sentry_trace, environment.sentry_origin],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    }

    
    //subscribe to load state
    this.loading$ = this.store.select(isLoading).pipe(delay(0)).subscribe((loader: IAppLoader) => {
      // console.log("loading called", loader)
      
      if (loader.loading) {
        this.isLoading = true;
      } else {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
      // this.isLoading = loader.loading;


      this.message = loader.message || '';

      if (this.isLoading == false) {
        // clear the message
        this.message = '';
      }
    });

  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    this.store.dispatch(loadLookup({lookup: LookupType.Public}));
  }

  ngOnDestroy() {
    this.config$.unsubscribe();
    this.loading$.unsubscribe();
    this.navigating$.unsubscribe();
    // this.cognito$.unsubscribe();
  }

  /**
   * logs out of the app
   */
  // public async logOut(): Promise<void> { return this.util.logOut(true);  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.store.dispatch(updateScrenHeight({height: window.innerHeight}));
    this.store.dispatch(updateScreenWidth({width: window.innerWidth}));
    // console.log("Window Resize: " + window.innerHeight + " "  + window.innerWidth);
  }
}
